<template>
    <div>
       <v-card :color="color">
          <v-card-text>
            <v-row justify="center" align="start" >
              <v-col cols="12" sm="12" md="12" lg="6">
                <span style="font-size:16px;font-weight:400;padding-right:15px;">Filter by</span>
                <v-btn-toggle small v-model="toggle_filter" dense color="info">
                  <v-btn @click="monthlyClick(name)">
                    Monthly
                  </v-btn>

                  <v-btn @click="quartelyClick(name)">
                    Quartely
                  </v-btn>

                  <v-btn @click="yearlyClick(name)">
                    Yearly
                  </v-btn>

                </v-btn-toggle>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="6">
                <v-card
                max-width="330"
                height="180"
                style="margin-left: auto;"
                outlined
                >
                <v-card-text>
                  <p class="text-h6 text--primary">
                  {{summaryTitle}}
                  </p>
                  <div class="text--primary" v-for="item, index in summary" :key="index" style="font-size:14px;margin:5px;">
                    {{item.text}}: <strong>{{item.value}} {{(name === 'revenue' ? 'SGD' : (name === 'renewal') ? '' : 'Days')}}</strong>
                    <div v-if="name === 'revenue' && index+1 === summary.length" style="font-size:14px;margin:5px 0px;">Shortfall: <strong>{{(target - item.value)}} SGD</strong></div>                    
                  </div>
                </v-card-text>
              </v-card>
              </v-col>
            </v-row>
            <v-row justify="center" align="center" style="margin-top:30px;" >
              <v-col cols="12" sm="12" >
                <canvas :id="name" width="500" height="200" ></canvas>
              </v-col>
            </v-row>
             <v-row justify="center" align="center" style="margin-top:20px;margin-bottom:20px;">
              <v-col cols="12" sm="12" align="end" >
                <v-btn color="info" @click="detailCLick(name)">Details</v-btn>
              </v-col>           
            </v-row>
          </v-card-text>
       </v-card>
    </div>
</template>
<script>
import Chart from 'chart.js';
import mockUpData from './chart-data.json'
export default {
  name: 'Bar-Chart',
  props: ['name', 'summaryTitle', 'summary', 'chartData', 'target', 'color'],
  data() {
    return {
      toggle_filter: 0,
      MONTHLY_DATA: []
    }
  },
  mounted() {
    setTimeout(() => {
      this.loadCharts()
    }, 1000)
  },
  methods: {
    async loadCharts() {
      let data = await this.chartData
      if (this.name === 'completion') {
        this.renderCompletionChart(data)
      } else if (this.name === 'revenue') {
        this.renderRevenueChart(data)
      } else {
        this.renderRenewalChart(data)
      }
    },
    renderCompletionChart(chartData) {
      var ctx = document.getElementById(this.name);

      const config = {
        type: 'bar',
        data: chartData,
        options: {
          responsive: true,
          interaction: {
            intersect: false
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            }
          }
        }
      };
      if (window.completionChart !== undefined) {
        window.completionChart.destroy()
      }
      // eslint-disable-next-line
      window.completionChart = new Chart(ctx, config)
      // window.completion.render()
      // window.completion.update()
    },
    renderRevenueChart(chartData) {
      var ctx = document.getElementById(this.name);

      const config = {
        type: 'bar',
        data: chartData,
        options: {
          responsive: true,
          interaction: {
            intersect: false
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            }
          }
        }
      };
      if (window.revenueChart !== undefined) {
        window.revenueChart.destroy()
      }
      // eslint-disable-next-line
      window.revenueChart = new Chart(ctx, config)
      // let revenueChart = new Chart(ctx, config)
      // revenueChart.render()
      // revenueChart.update()
    },
    renderRenewalChart(chartData) {
      var ctx = document.getElementById(this.name);

      const config = {
        type: 'bar',
        data: chartData,
        options: {
          responsive: true,
          interaction: {
            intersect: false
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true
            }
          }
        }
      };
      if (window.renewalChart !== undefined) {
        window.renewalChart.destroy()
      }
      // eslint-disable-next-line
      window.renewalChart = new Chart(ctx, config)
      // let revenueChart = new Chart(ctx, config)
      // revenueChart.render()
      // revenueChart.update()
    },
    detailCLick(name) {
      if (name.toLowerCase() === 'completion') this.$router.push({name: 'am-speed'})
      else if (name.toLowerCase() === 'renewal') this.$router.push({name: 'am-spend-campaign-report'})
      else if (name.toLowerCase() === 'average_amount') this.$router.push({name: 'am-spend-campaign-report'})
      else this.$router.push({name: 'am-spend-revenue'})
    },
    monthlyClick(name) {
      if (name.toLowerCase() === 'completion') {
        this.renderCompletionChart(mockUpData.Speed.COMPLETION.MONTHLY)
        this.calculateCompletionSummary(mockUpData.Speed.COMPLETION.MONTHLY, 12)
      } else if (name.toLowerCase() === 'renuve') {
        this.renderRevenueChart(mockUpData.Speed.COMPLETION.MONTHLY)
        this.calculateRevenueSummary(mockUpData.Speed.COMPLETION.MONTHLY)
      } else {
        this.renderRenewalChart(mockUpData.Spend.RENEWAL.MONTHLY)
        this.calculateRenewalSummary(mockUpData.Spend.RENEWAL.MONTHLY)
      }
    },
    quartelyClick(name) {
      if (name.toLowerCase() === 'completion') {
        this.renderCompletionChart(mockUpData.Speed.COMPLETION.QUARTELY)
        this.calculateCompletionSummary(mockUpData.Speed.COMPLETION.QUARTELY, 4)
      } else if (name.toLowerCase() === 'revenue') {
        this.renderRevenueChart(mockUpData.Speed.COMPLETION.QUARTELY)
        this.calculateRevenueSummary(mockUpData.Speed.COMPLETION.QUARTELY)
      } else {
        this.renderRenewalChart(mockUpData.Spend.RENEWAL.QUARTELY)
        this.calculateRenewalSummary(mockUpData.Spend.RENEWAL.QUARTELY)
      }
    },
    yearlyClick(name) {
      if (name.toLowerCase() === 'completion') {
        this.renderCompletionChart(mockUpData.Speed.COMPLETION.YEARLY)
        this.calculateCompletionSummary(mockUpData.Speed.COMPLETION.YEARLY, 6)
      } else if (name.toLowerCase() === 'revenue') {
        this.renderRevenueChart(mockUpData.Speed.COMPLETION.YEARLY)
        this.calculateRevenueSummary(mockUpData.Speed.COMPLETION.YEARLY)
      } else {
        this.renderRenewalChart(mockUpData.Spend.RENEWAL.YEARLY)
        this.calculateRenewalSummary(mockUpData.Spend.RENEWAL.YEARLY)
      }
    },
    calculateCompletionSummary(data, totalCount) {
      this.summary = []
      const dataset = data.datasets
      dataset.map((item) => {
        let avgValue = item.data.reduce((a, b) => a + b) / totalCount
        let summaryObj = {
          'text': item.label,
          'value': Math.round(avgValue)
        }
        this.summary.push(summaryObj)
      })
    },
    calculateRevenueSummary(data) {
      // const dataset = CData.Speed.REVENUE.MONTHLY.datasets
      this.summary = []
      const dataset = data.datasets
      dataset.map((item) => {
        let summaryObj = {
          'text': item.label,
          'value': item.data.reduce((a, b) => a + b)
        }
        this.summary.push(summaryObj)
      })
    },
    calculateRenewalSummary(data) {
      // const dataset = CData.Speed.REVENUE.MONTHLY.datasets
      this.summary = []
      const dataset = data.datasets
      let total = 0
      dataset.map((item) => {
        let summaryObj = {
          'text': item.label,
          'value': item.data.reduce((a, b) => a + b)
        }
        total += summaryObj.value
        this.summary.push(summaryObj)
      })

      let totalRenewal = {
        'text': 'Total',
        'value': total
      }
      this.summary.push(totalRenewal)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Bar.vue?09f143bc